import { environment } from '../../../environments/environment';

export class AppSettings {
  public static API_ENDPOINT = environment.apiUrl;
  
  public static readonly AUTH_LOGIN = `${AppSettings.API_ENDPOINT}/auth/login`;
  public static readonly AUTH_LOGOUT = `${AppSettings.API_ENDPOINT}/auth/logout`;
  public static readonly AUTH_ME = `${AppSettings.API_ENDPOINT}/auth/me`;
  public static readonly AUTH_REFRESH = `${AppSettings.API_ENDPOINT}/auth/refresh`;
  public static readonly AUTH_MICROSOFT = `${AppSettings.API_ENDPOINT}/login/microsoft`;
  
  public static readonly PROJECTS = `${AppSettings.API_ENDPOINT}/projects`;
  public static readonly DASHBOARD_STATS = `${AppSettings.API_ENDPOINT}/dashboard/stats`;
  public static readonly PROJECT_CATALOGS = `${AppSettings.API_ENDPOINT}/project-catalogs`;
  
  public static readonly DIRECTION_TASKS = `${AppSettings.API_ENDPOINT}/direction-tasks`;
  public static readonly DIRECTION_TASK_CATALOGS = `${AppSettings.API_ENDPOINT}/direction-task-catalogs`;
  public static readonly USERS = `${AppSettings.API_ENDPOINT}/users`;
  public static readonly NOTIFICATIONS = `${AppSettings.API_ENDPOINT}/notifications/upcoming`;
  
  public static getDirectionTaskUrl(id: number | string) {
    return `${AppSettings.DIRECTION_TASKS}/${id}`;
  }

  public static getDirectionTaskAttachmentsUrl(id: number | string) {
    return `${AppSettings.DIRECTION_TASKS}/${id}/attachments`;
  }

  public static getDirectionTaskAttachmentDownloadUrl(taskId: number | string, attachmentId: number | string) {
    return `${AppSettings.DIRECTION_TASKS}/${taskId}/attachments/${attachmentId}/download`;
  }

  public static getDirectionTaskCommentsUrl(id: number | string) {
    return `${AppSettings.DIRECTION_TASKS}/${id}/comments`;
  }

  public static getUserRoleUrl(userId: number | string) {
    return `${AppSettings.USERS}/${userId}/role`;
  }

  public static getUserToggleStatusUrl(userId: number | string) {
    return `${AppSettings.USERS}/${userId}/toggle-status`;
  }

  public static getProjectStatusUrl(id: number | string) {
    return `${AppSettings.PROJECTS}/${id}/status`;
  }
  
  public static getProjectAttachmentsUrl(id: number | string) {
    return `${AppSettings.PROJECTS}/${id}/attachments`;
  }
  
  public static getProjectAttachmentUrl(projectId: number | string, attachmentId: number | string) {
    return `${AppSettings.PROJECTS}/${projectId}/attachments/${attachmentId}`;
  }

  public static getProjectAttachmentDownloadUrl(projectId: number | string, attachmentId: number | string) {
    return `${AppSettings.PROJECTS}/${projectId}/attachments/${attachmentId}/download`;
  }
  
  public static getProjectCommentsUrl(id: number | string) {
    return `${AppSettings.PROJECTS}/${id}/comments`;
  }
  
  public static getProjectCommentUrl(projectId: number | string, commentId: number | string) {
    return `${AppSettings.PROJECTS}/${projectId}/comments/${commentId}`;
  }
  
  public static getProjectHistoryUrl(id: number | string) {
    return `${AppSettings.PROJECTS}/${id}/history`;
  }
}
